import { c as _c } from "react/compiler-runtime";
import { Stack } from "@mui-wrapper";
import { Text } from "@flat-ui";
import { ListItemCardMobile } from "@components/common/mobile/list-item-card-mobile";
import { generateMemberProfileRoute } from "@router/router-helper";
import { RoleColumn } from "@components/table/members/members-column/role-column/role-column";
import { UserAvatarWithMenu } from "@components/user-more-info-menu/user-avatar-with-menu";
import { MemberStatus } from "@components/table/members/members-column/status-column/member-status";
import { withEllipsis } from "@styles/common-styles";
/**
 * Renders a single member item in the mobile members list view.
 * Displays member avatar, email, role, name/status, and menu options.
 */
export function MembersMobileViewItem(t0) {
  const $ = _c(30);
  const {
    member,
    companyId,
    tableSubject,
    menuItems,
    group,
    selectedProject
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      justifyContent: "center"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== member) {
    t2 = <Stack sx={t1}><UserAvatarWithMenu member={member} /></Stack>;
    $[1] = member;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      ...withEllipsis
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== member.email) {
    t4 = <Text component="var" variant="labelM" sx={t3}>{member.email}</Text>;
    $[4] = member.email;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== member.identity || $[7] !== member.role) {
    t5 = {
      identity: member.identity,
      role: member.role
    };
    $[6] = member.identity;
    $[7] = member.role;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== companyId || $[10] !== group || $[11] !== selectedProject || $[12] !== t5 || $[13] !== tableSubject) {
    t6 = <RoleColumn companyId={companyId} subjectType={tableSubject} isReadOnly={true} memberIdentityRole={t5} group={group} selectedProject={selectedProject} />;
    $[9] = companyId;
    $[10] = group;
    $[11] = selectedProject;
    $[12] = t5;
    $[13] = tableSubject;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t4 || $[16] !== t6) {
    t7 = <Stack>{t4}{t6}</Stack>;
    $[15] = t4;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== companyId || $[19] !== member.identity) {
    t8 = generateMemberProfileRoute(companyId, member.identity);
    $[18] = companyId;
    $[19] = member.identity;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== member) {
    t9 = member.name ? <Text component="var" variant="bodyM" sx={{
      ...withEllipsis
    }}>{member.name}</Text> : <MemberStatus member={member} />;
    $[21] = member;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== member || $[24] !== menuItems || $[25] !== t2 || $[26] !== t7 || $[27] !== t8 || $[28] !== t9) {
    t10 = <ListItemCardMobile item={member} image={t2} title={t7} href={t8} subtitle={t9} menuItems={menuItems} />;
    $[23] = member;
    $[24] = menuItems;
    $[25] = t2;
    $[26] = t7;
    $[27] = t8;
    $[28] = t9;
    $[29] = t10;
  } else {
    t10 = $[29];
  }
  return t10;
}